/* eslint-disable react/prop-types */
import { DeleteOutline } from '@mui/icons-material'
import { Box, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { memo, useCallback } from 'react'
import { MAX_IMAGE_SIZE_BYTES, MAX_IMAGE_SIZE_MB } from '../../Products/components/Dropzone'
import { useDropzone } from 'react-dropzone'

const AddFoto: React.FC<any> = (props: any) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const { foto, setFoto, setDropError, gif, medidas } = props

  const onDrop = useCallback(async (acceptedFiles: File[], rejectedFiles: any[]) => {
    setDropError(undefined)

    if (rejectedFiles && rejectedFiles.length > 0) {
      rejectedFiles.forEach((file: any) => {
        file.errors.forEach((err: any) => {
          if (err.code === 'file-invalid-type') setDropError('Solamente podés subir archivos JPG, JPEG o PNG')
          else setDropError('Error desconocido')
        })
      })
      return
    }

    const file = acceptedFiles[0]
    if (!file) return
    props.setFilename && props.setFilename(file.name.replace(/\.[^/.]+$/, ''))

    if (file.size > MAX_IMAGE_SIZE_BYTES) {
      setDropError(`El tamaño máximo de la imagen es de ${MAX_IMAGE_SIZE_MB}MB`)
      return
    }

    if (medidas) {
      const imageBitmap = await createImageBitmap(file)
      const [requiredWidth, requiredHeight] = medidas.split('x').map(Number)
      if (imageBitmap.height !== requiredHeight || imageBitmap.width !== requiredWidth) {
        setDropError(
          `La imagen debe tener dimensiones de ${requiredWidth}x${requiredHeight}px. ` +
            `Tu imagen tiene ${imageBitmap.width}x${imageBitmap.height}px.`
        )
        return
      }
    }

    const reader = new FileReader()
    reader.onloadend = () => setFoto(reader.result as string)
    reader.readAsDataURL(file)
  }, [])

  const {
    getRootProps,
    getInputProps,
    open: openFiles,
    isDragActive
  } = useDropzone({
    onDrop,
    noClick: true,
    noKeyboard: true,
    accept: {
      'image/jpeg': [],
      'image/png': [],
      'image/jpg': [],
      ...(gif && { 'image/gif': [] })
    },
    maxFiles: 1
  })

  return (
    <>
      {/* Dropzone */}
      <Box
        {...getRootProps()}
        sx={{
          border: '2px dashed #aaa',
          borderRadius: 2,
          p: foto ? 0 : 3,
          textAlign: 'center',
          cursor: 'pointer',
          bgcolor: isDragActive ? 'action.hover' : 'transparent',
          display: 'inline-block'
        }}
      >
        <input {...getInputProps()} />

        {!foto ? (
          <>
            {isMobile ? (
              <Typography onClick={() => openFiles()}>Tocá para seleccionar</Typography>
            ) : (
              <Typography onClick={() => openFiles()}>
                {isDragActive ? 'Soltá la foto aquí...' : 'Arrastrá una foto o hacé click para seleccionar'}
              </Typography>
            )}
          </>
        ) : (
          <>
            <Box sx={{ position: 'relative', display: 'inline-block', width: '100%' }}>
              <img
                src={foto}
                alt="foto"
                style={{
                  maxWidth: '100%',
                  display: 'block',
                  borderRadius: '8px'
                }}
              />
              {/* Botón para eliminar la imagen */}
              <IconButton
                onClick={() => setFoto(null)}
                sx={{
                  position: 'absolute',
                  top: 8,
                  right: 8,
                  bgcolor: 'rgba(0,0,0,0.5)',
                  color: 'white',
                  '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' }
                }}
              >
                <DeleteOutline />
              </IconButton>
            </Box>
          </>
        )}
      </Box>
    </>
  )
}

export default memo(AddFoto)
